export const environment = {
  production: true,
  apiUrl: 'https://apim.credemtel.it/pecmanager-credem/',
  feUrl: 'https://webpec.credemtel.it/',
  recaptchaSiteKey: '6LdR20IaAAAAAKqcx-xzc-NxDbwa8txdklsK7G2b',
  apiOauthUrl: `https://api-oauth.credemtel.it/account/cambiopassword`,
  azureAuthUrl: `https://login.microsoftonline.com/a6c1ea13-42d0-4567-9f2f-9e12e4713792/oauth2/v2.0/authorize?client_id=70c87da8-ef1d-47ba-bd54-d3a6d465806d&redirect_uri=https://pm3.dev.platfoza.com/adfsauthcallback&response_type=code&scope=openid%20profile&response_mode=query`,
  oidcSignInUri: 'https://webpec.credemtel.it/sign-in/oidc',
  oidcCredemSignInUri: 'https://webpec.credemtel.it/sign-in/oidc-credem',
  renewUri: 'https://webpec.credemtel.it/sign-in/renew',
  changeOrganizationUri:
    'https://webpec.credemtel.it/sign-in/changeorganization',
  plugin: [],
  autoSaveIntervalMs: 10000,
  userActivityTimeoutMs: 1000 * 60 * 60 * 3,
  userRenewTokenIntervalMs: 1000 * 60 * 5,
  language: 'it',
  systemUsers: ['alexey.gukezhev@esterni.credemtel.it'],
  cookieAnchor: 'jwtTokenAnchorCredem',
  xApiKey: 'BvpUmE0tmcMAZFeFFbFzUkONBgBzTAx0',
  isCredem: true,
};
